import { FormField, Select } from "grommet";
import React from "react";

const SelectionFormField = ({
  label,
  id,
  handleBlur,
  setValues,
  touched,
  values,
  errors,
  options,
}: {
  label: string;
  id: string;
  handleChange: any;
  setValues: any;
  handleBlur: any;
  touched: any;
  values: any;
  errors: any;
  options: string[];
}) => (
  <FormField label={label} error={touched[id] && errors[id]} required name={id}>
    <Select
      id={id}
      name={id}
      options={options}
      value={values[id]}
      onChange={({ option }) => {
        setValues({ ...values, [id]: option })
      }}
    />
  </FormField>
)


export default SelectionFormField;


